import isEmpty from 'lodash/isEmpty';
import { CheckoutState } from '../../state';
import { getOptionalQuestionsForAttendees } from './attendees';
import { getOptionalQuestionsForBuyer } from './getOptionalQuestionsForBuyer';

export const hasOptionalQuestions = (state: CheckoutState) =>
    !isEmpty(getOptionalQuestionsForBuyer(state)) ||
    getOptionalQuestionsForAttendees(state).some(
        (attendee) => !isEmpty(attendee.survey),
    );
